import {
    GET_ALL_VERSIONS,
    GET_ALL_VERSIONS_SUCCESS,
    GET_ALL_VERSIONS_ERROR,
    GET_ALL_VERSIONS_BY_COMMUNITY,
    GET_ALL_VERSIONS_BY_COMMUNITY_SUCCESS,
    GET_ALL_VERSIONS_BY_COMMUNITY_ERROR,
    CLEAR_VERSIONS
} from "../constants/versionConstants";

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};

function ehubVersionReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_VERSIONS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'VERSION',
                'loadingMessage': 'THE VERSIONS ARE BEING LOADED',
                'type': action.type
            });
        case GET_ALL_VERSIONS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case GET_ALL_VERSIONS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'ehubVErsionData': action.data
            });
        case GET_ALL_VERSIONS_BY_COMMUNITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'VERSION',
                'loadingMessage': 'THE VERSIONS ARE BEING LOADED',
                'type': action.type
            });
        case GET_ALL_VERSIONS_BY_COMMUNITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case GET_ALL_VERSIONS_BY_COMMUNITY_SUCCESS:
            if (state.ehubVErsionData) {
                const oldData = state.ehubVErsionData.filter(device => !action.data.some(ver => ver._id === device._id));
                action.data = oldData.concat(action.data);
            }
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'ehubVErsionData': action.data
            });
        case CLEAR_VERSIONS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'ehubVErsionData': []
            });
        default:
            return state;
    }
}

export default ehubVersionReducer;

